// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Print Container - Forces single page */
.print-container {
  background: white;
}

.single-page-content {
  background: white;
  max-width: 210mm;
  margin: 0 auto;
  padding: 0;
}

.receipt-copy-wrapper {
  margin-bottom: 15px;
}
.receipt-copy-wrapper:last-child {
  margin-bottom: 0;
}

.copy-separator {
  border-top: 2px dashed #ccc;
  margin: 10px 0;
}

/* Table Styles */
.items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
}
.items-table th, .items-table td {
  border: 1px solid #000;
  padding: 3px 4px;
}
.items-table th {
  background-color: #e6f2ff;
  font-weight: 600;
}
.items-table .total-row {
  background-color: #f0f7ff;
}
.items-table .truncate {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Summary Box */
.summary-box {
  width: 180px;
  border: 1px solid #000;
  border-radius: 4px;
}
.summary-box .summary-content {
  font-size: 9px;
}
.summary-box .summary-content .summary-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;
  border-bottom: 1px solid #e5e7eb;
}
.summary-box .summary-content .summary-row span:first-child {
  width: 100px;
}
.summary-box .summary-content .summary-row span:nth-child(2) {
  width: 10px;
}
.summary-box .summary-content .summary-row span:last-child {
  flex: 1 1;
  text-align: left;
}
.summary-box .summary-content .summary-divider {
  height: 8px;
  border-bottom: 1px solid #e5e7eb;
}
.summary-box .summary-content .signature-text {
  padding: 8px 8px 4px;
}
.summary-box .summary-content div:last-child {
  padding: 4px 8px 8px;
}

/* Footer Section */
.footer-section {
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  margin-top: 10px;
}
.footer-section .terms {
  flex: 1 1;
  line-height: 1.3;
}
.footer-section .terms div {
  margin-bottom: 2px;
}
.footer-section .copy-type {
  flex: 1 1;
  text-align: center;
}
.footer-section .signature {
  flex: 1 1;
  text-align: right;
}

.disclaimer {
  text-align: center;
  font-size: 8px;
  font-style: italic;
  margin-top: 8px;
}

/* Utility Classes */
.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.font-bold {
  font-weight: 700;
}

.font-semibold {
  font-weight: 600;
}

.italic {
  font-style: italic;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Spacing */
.mb-1 {
  margin-bottom: 4px;
}

.mb-2 {
  margin-bottom: 8px;
}

.mt-1 {
  margin-top: 4px;
}

.mt-2 {
  margin-top: 8px;
}

.ml-2 {
  margin-left: 8px;
}

.mr-2 {
  margin-right: 8px;
}

.p-2 {
  padding: 8px;
}

.px-2 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 4px;
  padding-bottom: 4px;
}

.gap-2 {
  gap: 8px;
}

/* Borders */
.border {
  border: 1px solid #000;
}

.border-black {
  border-color: #000;
}

.border-b {
  border-bottom: 1px solid #000;
}

.border-dotted {
  border-style: dotted;
}

.rounded {
  border-radius: 4px;
}

/* Flex & Grid */
.flex {
  display: flex;
}

.flex-1 {
  flex: 1 1;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.grid {
  display: grid;
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

/* Header Image */
.header-img {
  max-width: 100%;
  max-height: 60px;
  object-fit: contain;
}

.signature-line {
  display: inline-block;
  width: 60px;
  border-bottom: 1px solid #000;
  margin: 0 4px;
}

/* ================================
   CRITICAL PRINT CSS - FORCES SINGLE PAGE
================================ */
@media print {
  @page {
    size: A4 portrait;
    margin: 3mm;
  }
  body {
    margin: 0;
    padding: 0;
    background: white;
  }
  /* Force everything onto one page */
  .print-container,
  .single-page-content,
  .receipt-copy-wrapper {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    break-after: avoid !important;
    page-break-after: avoid !important;
    break-before: avoid !important;
    page-break-before: avoid !important;
  }
  /* Ensure no page breaks anywhere */
  .single-page-content {
    position: relative;
    height: auto;
    min-height: 0;
    max-height: none;
    overflow: visible;
  }
  /* Prevent page breaks between copies */
  .copy-separator {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  /* Compact everything to fit */
  .receipt-copy-wrapper {
    margin-bottom: 8px;
    padding: 0;
  }
  .items-table {
    font-size: 8px;
  }
  .items-table th, .items-table td {
    padding: 2px 3px;
  }
  .summary-box {
    width: 160px;
  }
  .summary-box .summary-content {
    font-size: 8px;
  }
  .summary-box .summary-content .summary-row {
    padding: 2px 6px;
  }
  .summary-box .summary-content .summary-row span:first-child {
    width: 90px;
  }
  .footer-section {
    font-size: 8px;
    margin-top: 6px;
  }
  .disclaimer {
    font-size: 7px;
    margin-top: 4px;
  }
  .header-img {
    max-height: 50px;
  }
  /* Remove extra spacing */
  .mb-2 {
    margin-bottom: 4px;
  }
  .mb-1 {
    margin-bottom: 2px;
  }
  .p-2 {
    padding: 4px;
  }
  /* Force all content to stay together */
  * {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  /* Override any automatic page breaks */
  div, section, article, main {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  /* Ensure tables don't break */
  table, tr, td, th {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/customer_app/Customer_V5/ERF/reciptePrint.scss"],"names":[],"mappings":"AAAA,yCAAA;AACA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,2BAAA;EACA,cAAA;AAAF;;AAGA,iBAAA;AACA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAAF;AAEE;EACE,sBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,yBAAA;EACA,gBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;;AAOA,gBAAA;AACA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;AAJF;AAME;EACE,cAAA;AAJJ;AAMI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gCAAA;AAJN;AAMM;EACE,YAAA;AAJR;AAOM;EACE,WAAA;AALR;AAQM;EACE,SAAA;EACA,gBAAA;AANR;AAUI;EACE,WAAA;EACA,gCAAA;AARN;AAWI;EACE,oBAAA;AATN;AAYI;EACE,oBAAA;AAVN;;AAeA,mBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;AAZF;AAcE;EACE,SAAA;EACA,gBAAA;AAZJ;AAcI;EACE,kBAAA;AAZN;AAgBE;EACE,SAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,SAAA;EACA,iBAAA;AAfJ;;AAmBA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAhBF;;AAmBA,oBAAA;AACA;EAAa,gBAAA;AAfb;;AAgBA;EAAe,kBAAA;AAZf;;AAaA;EAAc,iBAAA;AATd;;AAUA;EAAa,gBAAA;AANb;;AAOA;EAAiB,gBAAA;AAHjB;;AAIA;EAAU,kBAAA;AAAV;;AACA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA,YAAA;AACA;EAAQ,kBAAA;AAGR;;AAFA;EAAQ,kBAAA;AAMR;;AALA;EAAQ,eAAA;AASR;;AARA;EAAQ,eAAA;AAYR;;AAXA;EAAQ,gBAAA;AAeR;;AAdA;EAAQ,iBAAA;AAkBR;;AAjBA;EAAO,YAAA;AAqBP;;AApBA;EAAQ,iBAAA;EAAmB,kBAAA;AAyB3B;;AAxBA;EAAQ,gBAAA;EAAkB,mBAAA;AA6B1B;;AA5BA;EAAS,QAAA;AAgCT;;AA9BA,YAAA;AACA;EAAU,sBAAA;AAkCV;;AAjCA;EAAgB,kBAAA;AAqChB;;AApCA;EAAY,6BAAA;AAwCZ;;AAvCA;EAAiB,oBAAA;AA2CjB;;AA1CA;EAAW,kBAAA;AA8CX;;AA5CA,gBAAA;AACA;EAAQ,aAAA;AAgDR;;AA/CA;EAAU,SAAA;AAmDV;;AAlDA;EAAmB,8BAAA;AAsDnB;;AArDA;EAAgB,mBAAA;AAyDhB;;AAxDA;EAAQ,aAAA;AA4DR;;AA3DA;EAAe,qCAAA;AA+Df;;AA7DA,iBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAgEF;;AA7DA;EACE,qBAAA;EACA,WAAA;EACA,6BAAA;EACA,aAAA;AAgEF;;AA7DA;;kCAAA;AAGA;EACE;IACE,iBAAA;IACA,WAAA;EAgEF;EA7DA;IACE,SAAA;IACA,UAAA;IACA,iBAAA;EA+DF;EA5DA,mCAAA;EACA;;;IAGE,8BAAA;IACA,mCAAA;IACA,6BAAA;IACA,kCAAA;IACA,8BAAA;IACA,mCAAA;EA8DF;EA3DA,mCAAA;EACA;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;IACA,iBAAA;EA6DF;EA1DA,uCAAA;EACA;IACE,8BAAA;IACA,mCAAA;EA4DF;EAzDA,8BAAA;EACA;IACE,kBAAA;IACA,UAAA;EA2DF;EAxDA;IACE,cAAA;EA0DF;EAxDE;IACE,gBAAA;EA0DJ;EAtDA;IACE,YAAA;EAwDF;EAtDE;IACE,cAAA;EAwDJ;EAtDI;IACE,gBAAA;EAwDN;EAtDM;IACE,WAAA;EAwDR;EAlDA;IACE,cAAA;IACA,eAAA;EAoDF;EAjDA;IACE,cAAA;IACA,eAAA;EAmDF;EAhDA;IACE,gBAAA;EAkDF;EA/CA,yBAAA;EACA;IACE,kBAAA;EAiDF;EA9CA;IACE,kBAAA;EAgDF;EA7CA;IACE,YAAA;EA+CF;EA5CA,uCAAA;EACA;IACE,8BAAA;IACA,mCAAA;EA8CF;EA3CA,uCAAA;EACA;IACE,8BAAA;IACA,mCAAA;EA6CF;EA1CA,8BAAA;EACA;IACE,8BAAA;IACA,mCAAA;EA4CF;AACF","sourcesContent":["/* Print Container - Forces single page */\n.print-container {\n  background: white;\n}\n\n.single-page-content {\n  background: white;\n  max-width: 210mm;\n  margin: 0 auto;\n  padding: 0;\n}\n\n.receipt-copy-wrapper {\n  margin-bottom: 15px;\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.copy-separator {\n  border-top: 2px dashed #ccc;\n  margin: 10px 0;\n}\n\n/* Table Styles */\n.items-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 10px;\n  \n  th, td {\n    border: 1px solid #000;\n    padding: 3px 4px;\n  }\n  \n  th {\n    background-color: #e6f2ff;\n    font-weight: 600;\n  }\n  \n  .total-row {\n    background-color: #f0f7ff;\n  }\n  \n  .truncate {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n/* Summary Box */\n.summary-box {\n  width: 180px;\n  border: 1px solid #000;\n  border-radius: 4px;\n  \n  .summary-content {\n    font-size: 9px;\n    \n    .summary-row {\n      display: flex;\n      justify-content: space-between;\n      padding: 4px 8px;\n      border-bottom: 1px solid #e5e7eb;\n      \n      span:first-child {\n        width: 100px;\n      }\n      \n      span:nth-child(2) {\n        width: 10px;\n      }\n      \n      span:last-child {\n        flex: 1;\n        text-align: left;\n      }\n    }\n    \n    .summary-divider {\n      height: 8px;\n      border-bottom: 1px solid #e5e7eb;\n    }\n    \n    .signature-text {\n      padding: 8px 8px 4px;\n    }\n    \n    div:last-child {\n      padding: 4px 8px 8px;\n    }\n  }\n}\n\n/* Footer Section */\n.footer-section {\n  display: flex;\n  justify-content: space-between;\n  font-size: 9px;\n  margin-top: 10px;\n  \n  .terms {\n    flex: 1;\n    line-height: 1.3;\n    \n    div {\n      margin-bottom: 2px;\n    }\n  }\n  \n  .copy-type {\n    flex: 1;\n    text-align: center;\n  }\n  \n  .signature {\n    flex: 1;\n    text-align: right;\n  }\n}\n\n.disclaimer {\n  text-align: center;\n  font-size: 8px;\n  font-style: italic;\n  margin-top: 8px;\n}\n\n/* Utility Classes */\n.text-left { text-align: left; }\n.text-center { text-align: center; }\n.text-right { text-align: right; }\n.font-bold { font-weight: 700; }\n.font-semibold { font-weight: 600; }\n.italic { font-style: italic; }\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Spacing */\n.mb-1 { margin-bottom: 4px; }\n.mb-2 { margin-bottom: 8px; }\n.mt-1 { margin-top: 4px; }\n.mt-2 { margin-top: 8px; }\n.ml-2 { margin-left: 8px; }\n.mr-2 { margin-right: 8px; }\n.p-2 { padding: 8px; }\n.px-2 { padding-left: 8px; padding-right: 8px; }\n.py-1 { padding-top: 4px; padding-bottom: 4px; }\n.gap-2 { gap: 8px; }\n\n/* Borders */\n.border { border: 1px solid #000; }\n.border-black { border-color: #000; }\n.border-b { border-bottom: 1px solid #000; }\n.border-dotted { border-style: dotted; }\n.rounded { border-radius: 4px; }\n\n/* Flex & Grid */\n.flex { display: flex; }\n.flex-1 { flex: 1; }\n.justify-between { justify-content: space-between; }\n.items-center { align-items: center; }\n.grid { display: grid; }\n.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }\n\n/* Header Image */\n.header-img {\n  max-width: 100%;\n  max-height: 60px;\n  object-fit: contain;\n}\n\n.signature-line {\n  display: inline-block;\n  width: 60px;\n  border-bottom: 1px solid #000;\n  margin: 0 4px;\n}\n\n/* ================================\n   CRITICAL PRINT CSS - FORCES SINGLE PAGE\n================================ */\n@media print {\n  @page {\n    size: A4 portrait;\n    margin: 3mm;\n  }\n  \n  body {\n    margin: 0;\n    padding: 0;\n    background: white;\n  }\n  \n  /* Force everything onto one page */\n  .print-container,\n  .single-page-content,\n  .receipt-copy-wrapper {\n    break-inside: avoid !important;\n    page-break-inside: avoid !important;\n    break-after: avoid !important;\n    page-break-after: avoid !important;\n    break-before: avoid !important;\n    page-break-before: avoid !important;\n  }\n  \n  /* Ensure no page breaks anywhere */\n  .single-page-content {\n    position: relative;\n    height: auto;\n    min-height: 0;\n    max-height: none;\n    overflow: visible;\n  }\n  \n  /* Prevent page breaks between copies */\n  .copy-separator {\n    break-inside: avoid !important;\n    page-break-inside: avoid !important;\n  }\n  \n  /* Compact everything to fit */\n  .receipt-copy-wrapper {\n    margin-bottom: 8px;\n    padding: 0;\n  }\n  \n  .items-table {\n    font-size: 8px;\n    \n    th, td {\n      padding: 2px 3px;\n    }\n  }\n  \n  .summary-box {\n    width: 160px;\n    \n    .summary-content {\n      font-size: 8px;\n      \n      .summary-row {\n        padding: 2px 6px;\n        \n        span:first-child {\n          width: 90px;\n        }\n      }\n    }\n  }\n  \n  .footer-section {\n    font-size: 8px;\n    margin-top: 6px;\n  }\n  \n  .disclaimer {\n    font-size: 7px;\n    margin-top: 4px;\n  }\n  \n  .header-img {\n    max-height: 50px;\n  }\n  \n  /* Remove extra spacing */\n  .mb-2 {\n    margin-bottom: 4px;\n  }\n  \n  .mb-1 {\n    margin-bottom: 2px;\n  }\n  \n  .p-2 {\n    padding: 4px;\n  }\n  \n  /* Force all content to stay together */\n  * {\n    break-inside: avoid !important;\n    page-break-inside: avoid !important;\n  }\n  \n  /* Override any automatic page breaks */\n  div, section, article, main {\n    break-inside: avoid !important;\n    page-break-inside: avoid !important;\n  }\n  \n  /* Ensure tables don't break */\n  table, tr, td, th {\n    break-inside: avoid !important;\n    page-break-inside: avoid !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
